import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Rutas } from '../../utiles/Rutas';

@Injectable({
  providedIn: 'root',
})
export class ExpedientesService {
  constructor(private http: HttpClient) {}

  addExpediente(datos): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(Rutas + 'add_expediente', datos, { headers });
  }

  getExpedientes(apellido: any, page?): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_expedientes_colaborador',
      JSON.stringify({ colaborador: apellido, page }),
      { headers }
    );
  }

  getExpedientesFiltros(
    apellido: any,
    filtro,
    pagination: boolean,
    page?
  ): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_expedientes_colaborador_filter',
      JSON.stringify({ colaborador: apellido, page, filtro, pagination }),
      { headers }
    );
  }

  getExpedientesPalma(apellido: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_expedientes_colaborador_palma',
      JSON.stringify({ colaborador: apellido }),
      { headers }
    );
  }

  getExpedientesHome(apellido: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_expedientes_colaborador_home',
      JSON.stringify({ colaborador: apellido }),
      { headers }
    );
  }
  getSolicitudes(apellido: any, filtro: any, page?: number): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_solicitudes_colaborador',
      JSON.stringify({ colaborador: apellido, filtro, page }),
      { headers }
    );
  }

  getVehiculo(dato: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_vehiculo_bastidor',
      JSON.stringify({ bastidor: dato }),
      { headers }
    );
  }

  getAyuda(dato: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_ayuda',
      JSON.stringify({ expediente: dato }),
      { headers }
    );
  }

  getSigla(dato: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'sigla_calle',
      JSON.stringify({ sigla: dato }),
      { headers }
    );
  }

  getExpedientesEstadisticas(apellido: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_expedientes_estadisticas',
      JSON.stringify({ colaborador: apellido }),
      { headers }
    );
  }

  getSolicitud(id: string): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_solicitud_id',
      JSON.stringify({ id: id }),
      { headers }
    );
  }

  getDocumentos(numExp: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_file_expediente',
      JSON.stringify({ idFile: numExp }),
      { headers }
    );
  }

  //Aun tengo que cambiar la funcion para que sea de facturas
  getFacturas(numExp: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_file_expediente',
      JSON.stringify({ idFile: numExp }),
      { headers }
    );
  }

  getDocumentosSolicitud(numSol: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_file_solicitud',
      JSON.stringify({ idFile: numSol }),
      { headers }
    );
  }

  getDocumentoss(numExp: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/pdf');
    return this.http.post(
      Rutas + 'get_files_expediente',
      JSON.stringify({ idExpediente: numExp }),
      { headers, responseType: 'arraybuffer' }
    );
  }

  //Aun tengo que cambiar la funcion para que sea de facturas
  getFacturass(numExp: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/pdf');
    return this.http.post(
      Rutas + 'get_files_expediente',
      JSON.stringify({ idExpediente: numExp }),
      { headers, responseType: 'arraybuffer' }
    );
  }

  getExpedientesEntreFechas(init, final, colaborador): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    // tslint:disable-next-line:max-line-length
    return this.http.post(
      Rutas + 'get_expedientes_colaborador/entre_fechas',
      JSON.stringify({ colaborador, initial: init, end: final }),
      { headers }
    );
  }

  getExpedientesEntreFechasPalma(init, final, colaborador): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    // tslint:disable-next-line:max-line-length
    return this.http.post(
      Rutas + 'get_expedientes_colaborador_palma/entre_fechas',
      JSON.stringify({ colaborador, initial: init, end: final }),
      { headers }
    );
  }

  sendFilesEmailCliente(id, nombre, solicitud, email): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'send_email_files_cliente',
      JSON.stringify({ id, nombre, solicitud, email }),
      { headers }
    );
  }

  multipleSearch(expedientes, colaborador): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_expedientes_filtro',
      JSON.stringify({ expedientes, colaborador }),
      { headers }
    );
  }

  multipleSearchBastidores(bastidores, colaborador): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_pedidos_bastidores_filtro',
      JSON.stringify({ bastidores, colaborador }),
      { headers }
    );
  }
  multipleSearchMatriculas(matriculas, colaborador): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_pedidos_matriculas_filtro',
      JSON.stringify({ matriculas, colaborador }),
      { headers }
    );
  }

  getBulkFilesExpediente(expedientes): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_files_expedientes_bulk',
      JSON.stringify({ expedientes }),
      { headers }
    );
  }

  //Aun tengo que cambiar la funcion para que sea de facturas
  getBulkFacturasExpediente(expedientes): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'get_files_expedientes_bulk',
      JSON.stringify({ expedientes }),
      { headers }
    );
  }

  cancelarProcesoFirma(id): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(Rutas + 'sigafirma/reject', JSON.stringify({ id }), {
      headers,
    });
  }

  cancelarProcesoFirmaDocumento(id): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'sigafirma/rejectmessage',
      JSON.stringify({ id }),
      { headers }
    );
  }

  ampliarProcesoFirma(id): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'sigafirma/extendset',
      JSON.stringify({ id }),
      { headers }
    );
  }

  reenviarFirmaSet(id): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'sigafirma/resendset',
      JSON.stringify({ id }),
      { headers }
    );
  }

  reenviarFormularioMoves(numeroPedido): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'send_email_form_reinicia',
      JSON.stringify({ id: numeroPedido }),
      { headers }
    );
  }
}
